import createHistory from 'history/createBrowserHistory';
const AppHistory = createHistory();
export default AppHistory;
